// Lib
import { FC, useEffect } from "react";
// Api
import { useGetMeQuery } from "rtkQuery/query/usersAPI";
// Hooks
import { useAppDispatch, useAppSelector } from "hooks/redux";
// Actions
import { setUser } from "rtkQuery/slices";
// Selectors
import { getUser, isAuth } from "rtkQuery/selectors";
// Helpers
import { isMatch } from "helpers/dataHelpers";
// Utils
import { token } from "utils/handleToken";

export const Me: FC = () => {
  const dispatch = useAppDispatch();

  const isAuthorized = useAppSelector(isAuth);
  const user = useAppSelector(getUser);

  const userAuthorized = isAuthorized && !!token.access.get();

  const { data } = useGetMeQuery(null, {
    skip: !userAuthorized,
    refetchOnReconnect: true,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
    pollingInterval: 30000,
  });

  useEffect(() => {
    if (!userAuthorized) return;

    if (!data) return;

    if (isMatch(user, data)) return;

    dispatch(setUser(data));
  }, [data]);

  return null;
};
